import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articleData } from "@/mocks/articles";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 z-40 bg-foreground-950/50 backdrop-blur-sm transition-opacity duration-300 ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={onClose}
      ></div>

      {/* Slide-in Panel */}
      <div
        className={`fixed top-0 right-0 z-50 h-full w-[300px] max-w-[85vw] bg-background-50 overflow-y-auto transition-transform duration-300 ease-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 h-16 border-b border-foreground-200/50">
          <span className="font-heading text-lg text-foreground-950">CSSBuy<span className="w-1.5 h-1.5 rounded-full bg-primary-500 inline-block mx-0.5 align-middle"></span>Sheet</span>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center rounded-lg text-foreground-600 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-close-line text-xl w-5 h-5 flex items-center justify-center"></i>
          </button>
        </div>

        {/* Nav Links */}
        <div className="px-5 py-6 space-y-1">
          <Link
            to="/"
            onClick={onClose}
            className="flex items-center gap-3 px-4 py-3 rounded-xl text-foreground-700 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-home-4-line text-lg w-5 h-5 flex items-center justify-center text-primary-500"></i>
            <span className="text-sm font-medium">Início</span>
          </Link>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            onClick={onClose}
            className="flex items-center gap-3 px-4 py-3 rounded-xl text-foreground-700 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line text-lg w-5 h-5 flex items-center justify-center text-primary-500"></i>
            <span className="text-sm font-medium">Guia de Compras</span>
          </a>
        </div>

        {/* Artigos Section */}
        <div className="px-5 pb-4">
          <p className="text-xs text-foreground-400 font-medium uppercase tracking-wider px-4 mb-2">Artigos SEO</p>
          {articleData.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              onClick={onClose}
              className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-foreground-600 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-article-line text-base w-4 h-4 flex items-center justify-center text-foreground-400"></i>
              <span className="text-xs leading-tight line-clamp-1">{article.title}</span>
            </Link>
          ))}
        </div>

        {/* Categorias Section */}
        <div className="px-5 pb-4">
          <p className="text-xs text-foreground-400 font-medium uppercase tracking-wider px-4 mb-2">Categorias</p>
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={onClose}
              className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-foreground-600 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-8 h-8 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0 overflow-hidden">
                <img src={cat.image} alt={cat.namePt} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <span className="text-xs">{cat.namePt}</span>
              <span className="text-[10px] text-foreground-400 ml-auto">{cat.count}+</span>
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="px-5 py-4 border-t border-foreground-200/50">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            onClick={onClose}
            className="flex items-center justify-center gap-2 w-full px-5 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            VER SPREADSHEET
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </>
  );
}